import React from 'react';
import { Factory, Settings, Package, Wrench, Cog, Hammer } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

export const Services = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const services = [
    {
      icon: Factory,
      title: t.services.conveyor.title,
      desc: t.services.conveyor.description,
      image: 'https://images.unsplash.com/photo-1651615832931-1f0540d43ef0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxjb252ZXlvciUyMHN5c3RlbXN8ZW58MHx8fHwxNzY5Nzc5Mzc0fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Settings,
      title: t.services.helical.title,
      desc: t.services.helical.description,
      image: 'https://images.unsplash.com/photo-1548683726-203119be6a39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxtZXRhbHdvcmslMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc2OTc3OTM5MHww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Package,
      title: t.services.chocolate.title,
      desc: t.services.chocolate.description,
      image: 'https://images.unsplash.com/photo-1747999060057-89b7a533f347?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxmYWN0b3J5JTIwcHJvZHVjdGlvbnxlbnwwfHx8fDE3Njk3NzkzODV8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Wrench,
      title: t.services.cnc.title,
      desc: t.services.cnc.description,
      image: 'https://images.unsplash.com/photo-1713371398485-7bde1bde9def?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxDTkMlMjBtYWNoaW5pbmd8ZW58MHx8fHwxNzY5Nzc5Mzc5fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Cog,
      title: t.services.custom.title,
      desc: t.services.custom.description,
      image: 'https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwbWFjaGluZXJ5fGVufDB8fHx8MTc2OTc3OTM2OXww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Hammer,
      title: t.services.metal.title,
      desc: t.services.metal.description,
      image: 'https://images.unsplash.com/photo-1745448797900-35d08e85e9db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxtZXRhbHdvcmslMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc2OTc3OTM5MHww&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.services.title}
          </h1>
          <p className="text-xl text-gray-600">{t.services.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300"
            >
              <div className="h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <service.icon className="text-blue-700" size={24} />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
